import _State from '@states/_State.js';

/**
 * State for tracking selected AI content elements
 * Map<elementId, { sessionId, messageIndex, elementType, content, timestamp }>
 * elementId format: `session-${sessionId}-msg-${idx}-${type}-${subIdx}`
 */
export const AiSelectedContentState = _State(
  'selectedContent',
  'setSelectedContent',
  new Map(),
);

/**
 * State for AI selection mode
 */
export const IsAiSelectionModeState = _State(
  'isAiSelectionMode',
  'setIsAiSelectionMode',
  false,
);
